(function () {
  'use strict';

  if (window.ShoevBenefitsGuide) {
    window.ShoevBenefitsGuide.init(document);
    return;
  }

  class ShoevBenefitsController {
    constructor(root) {
      this.root = root;
      this.choices = Array.from(root.querySelectorAll('[data-benefit-choices] button'));
      this.cards = Array.from(root.querySelectorAll('[data-product-model]'));
      this.track = root.querySelector('[data-benefit-products]');
      this.recommendation = root.querySelector('[data-benefit-recommendation]');
      this.recommendationTimer = null;
      this.onChoiceClick = this.onChoiceClick.bind(this);
      this.onChoiceKeydown = this.onChoiceKeydown.bind(this);

      this.choices.forEach((choice) => {
        choice.addEventListener('click', this.onChoiceClick);
        choice.addEventListener('keydown', this.onChoiceKeydown);
      });

      this.observePowerBars();
    }

    onChoiceClick(event) {
      this.selectModel(event.currentTarget, true);
    }

    onChoiceKeydown(event) {
      const currentIndex = this.choices.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.choices.length;
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.choices.length) % this.choices.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.choices.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.choices[nextIndex].focus();
      this.selectModel(this.choices[nextIndex], true);
    }

    selectModel(choice, shouldScroll) {
      const model = choice.dataset.model;
      const selectedCard = this.cards.find((card) => card.dataset.productModel === model);

      this.choices.forEach((item) => {
        item.setAttribute('aria-pressed', String(item === choice));
      });
      this.cards.forEach((card) => {
        const isSelected = card === selectedCard;
        const recommendationLabel = card.querySelector('.shoev-benefits__recommended-label');

        card.classList.toggle('is-recommended', isSelected);
        if (recommendationLabel) {
          recommendationLabel.setAttribute('aria-hidden', String(!isSelected));
        }
      });

      if (this.recommendation && this.recommendation.textContent.trim() !== choice.dataset.recommendation) {
        window.clearTimeout(this.recommendationTimer);
        this.recommendation.classList.add('is-changing');
        this.recommendationTimer = window.setTimeout(() => {
          this.recommendation.textContent = choice.dataset.recommendation;
          this.recommendation.classList.remove('is-changing');
        }, 120);
      }

      if (shouldScroll && selectedCard && window.matchMedia('(max-width: 749px)').matches) {
        this.centerCard(selectedCard);
      }
    }

    centerCard(card) {
      const trackBounds = this.track.getBoundingClientRect();
      const cardBounds = card.getBoundingClientRect();
      const offset = cardBounds.left + cardBounds.width / 2 - (trackBounds.left + trackBounds.width / 2);
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      this.track.scrollBy({ left: offset, behavior: behavior });
    }

    observePowerBars() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        this.root.classList.add('is-powers-visible');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.root.classList.add('is-powers-visible');
          this.observer.disconnect();
        }
      }, { threshold: 0.18 });
      this.observer.observe(this.root.querySelector('[data-benefit-products]'));
    }

    destroy() {
      this.choices.forEach((choice) => {
        choice.removeEventListener('click', this.onChoiceClick);
        choice.removeEventListener('keydown', this.onChoiceKeydown);
      });
      window.clearTimeout(this.recommendationTimer);
      if (this.observer) this.observer.disconnect();
      delete this.root.shoevBenefitsController;
    }
  }

  const guide = {
    init(scope) {
      scope.querySelectorAll('[data-shoev-benefits]').forEach((root) => {
        if (!root.shoevBenefitsController) {
          root.shoevBenefitsController = new ShoevBenefitsController(root);
        }
      });
    },
    destroy(scope) {
      scope.querySelectorAll('[data-shoev-benefits]').forEach((root) => {
        if (root.shoevBenefitsController) root.shoevBenefitsController.destroy();
      });
    }
  };

  window.ShoevBenefitsGuide = guide;
  guide.init(document);

  document.addEventListener('shopify:section:load', (event) => guide.init(event.target));
  document.addEventListener('shopify:section:unload', (event) => guide.destroy(event.target));
}());
